export default __webpack_public_path__ + "static/media/tiktok.b6cf5412.svg";